<template>
  <div id="home">
    <div>
      <van-nav-bar
          title="宏锦工程机械有限责任公司"
      >
        <template #right>
          <van-icon name="add-o" size="25" />
        </template>
      </van-nav-bar>
    </div>
    <!-- 上部分 1/5 内容 -->
    <div class="top-content">
      <!-- 这里可以放您的页面内容 -->
      <van-grid :column-num="4" class="custom-grid">
        <van-grid-item :text="`${data.sumSalary0 === undefined ? '—— —— ' : data.sumSalary0 }\n上月工资`" :style="{ whiteSpace: 'pre-line' }" />
        <van-grid-item :text="`${data.oilMonth0 === undefined ? '—— —— ' : data.oilMonth0 }\n上月油数`" :style="{ whiteSpace: 'pre-line' }" />
        <van-grid-item :text="`${data.oilDay0 === undefined ? '—— —— ' : data.oilDay0 }\n昨日油数`" :style="{ whiteSpace: 'pre-line' }" />
        <van-grid-item :text="`${data.carDay0 === undefined ? '—— —— ' : data.carDay0 }\n昨日车数`" :style="{ whiteSpace: 'pre-line' }" />
        <van-grid-item :text="`${data.sumSalary === undefined ? '—— —— ' : data.sumSalary }\n本月工资`" :style="{ whiteSpace: 'pre-line' }" />
        <van-grid-item :text="`${data.oilMonth === undefined ? '—— —— ' : data.oilMonth }\n本月油数`" :style="{ whiteSpace: 'pre-line' }" />
        <van-grid-item :text="`${data.oilDay === undefined ? '—— —— ' : data.oilDay }\n今日油数`" :style="{ whiteSpace: 'pre-line' }" />
        <van-grid-item :text="`${data.carDay === undefined ? '—— —— ' : data.carDay }\n今日油数`" :style="{ whiteSpace: 'pre-line' }" />
      </van-grid>
    </div>

    <!-- 下部分 1/5 四个框框 -->
    <div class="bottom-boxes">
      <van-row type="flex" justify="center">
        <van-col span="10">
          <router-link to="/staffTotal">
            <div class="box red">员工统计</div>
          </router-link>
        </van-col>
        <van-col span="10">
          <router-link to="/productionTotal">
            <div class="box blue">生产统计</div>
          </router-link>
        </van-col>
      </van-row>
      <van-row type="flex" justify="center">
        <van-col span="10">
          <router-link to="/salaryTotal">
            <div class="box green">薪资统计</div>
          </router-link>
        </van-col>
        <van-col span="10">
<!--          <router-link to="/staffTotal">-->
            <div class="box yellow" >配件统计</div>
<!--          </router-link>-->
        </van-col>
      </van-row>
    </div>

    <div>

      <!-- 通过 class-prefix 指定类名为 my-icon -->
      <van-grid :column-num="4" :border="false">
        <van-grid-item text="新增员工" >
          <template #icon>
            <span class="iconfont iconfont-yuangongrenzheng1"></span>
          </template>
        </van-grid-item>
        <van-grid-item icon="" text="新增部门" >
          <template #icon>
            <span class="iconfont iconfont-gongren"></span>
          </template>
        </van-grid-item>
        <van-grid-item icon="photo-o" text="新增请假" >
          <template #icon>
            <span class="iconfont iconfont-qingjiashenqing"></span>
          </template>
        </van-grid-item>
        <van-grid-item icon="photo-o" text="新增手记车数" >
          <template #icon>
            <span class="iconfont iconfont-deshi"></span>
          </template>
        </van-grid-item>
        <van-grid-item icon="photo-o" text="新增配件使用" >
          <template #icon>
            <span class="iconfont iconfont-peijianqianshou"></span>
          </template>
        </van-grid-item>
        <van-grid-item icon="photo-o" text="新增报销明细" >
          <template #icon>
            <span class="iconfont iconfont-baoxiaodan"></span>
          </template>
        </van-grid-item>
        <van-grid-item icon="photo-o" text="待定" >
          <template #icon>
            <span class="iconfont iconfont-gengduofuwu"></span>
          </template>
        </van-grid-item>
<!--        <van-grid-item icon="photo-o" text="待定" >-->
<!--          <template #icon>-->
<!--            <span class="iconfont iconfont-yuangongrenzheng1"></span>-->
<!--          </template>-->
<!--        </van-grid-item>-->
<!--        <van-grid-item icon="photo-o" text="待定" >-->
<!--          <template #icon>-->
<!--            <span class="iconfont iconfont-yuangongrenzheng1"></span>-->
<!--          </template>-->
<!--        </van-grid-item>-->
<!--        <van-grid-item icon="photo-o" text="待定" >-->
<!--          <template #icon>-->
<!--            <span class="iconfont iconfont-yuangongrenzheng1"></span>-->
<!--          </template>-->
<!--        </van-grid-item>-->
<!--        <van-grid-item icon="photo-o" text="待定" >-->
<!--          <template #icon>-->
<!--            <span class="iconfont iconfont-yuangongrenzheng1"></span>-->
<!--          </template>-->
<!--        </van-grid-item>-->
<!--        <van-grid-item icon="photo-o" text="待定" >-->
<!--          <template #icon>-->
<!--            <span class="iconfont iconfont-yuangongrenzheng1"></span>-->
<!--          </template>-->
<!--        </van-grid-item>-->
      </van-grid>
    </div>

  </div>
</template>
<script>

import {getCountData} from "@/api/home";

export default {
  data () {
    return {
      data: {},
    }
  },
  methods: {
    loading () {
      getCountData({deptId: 27}).then((response) => {
        this.data = response.data
      })
    }
  },
  mounted() {
    this.loading()
  }
}
</script>
<style scoped>
#home {
  height: 100vh;
  //background-color: #f0f0f0; /* 可以自定义背景色 */
}

.bottom-boxes {
  margin: 1vh 0 3vh 0;
  //height: 20vh; /* 下部分高度为 1/5 */
}

.van-grid-item {
  text-align: center;
}

.box {
  margin: 3vh 4vw 0 4vw;
  height: 6vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border: 2px solid #ccc; /* 边框 */
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* 阴影 */
}

.red {
  background-color: #add8e6; /* 浅蓝色背景 */
  color: #333; /* 文本颜色 */
}

.blue {
  background-color: #90ee90; /* 浅绿色背景 */
  color: #333; /* 文本颜色 */
}

.green {
  background-color: #c0c0e6; /* 浅紫色背景 */
  color: #333; /* 文本颜色 */
}

.yellow {
  background-color: #ffa07a; /* 浅橙色背景 */
  color: #333; /* 文本颜色 */
}
.iconfont {
  font-size: 35px;
}
</style>